var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid popular-categories-container"},[_c('card-list-header',{attrs:{"heading":_vm.heading}}),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.categories),function(category,index){return _c('popular-category',{key:index,attrs:{"slug":category}})}),1)],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e28e8a7e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Resources/assets/js/UI/components/popular-categories.vue
// module id = n6wA
// module chunks = 0